import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const show = () => true;
const hide = () => false;

export default createReducer(initialState, {
  [actionTypes.SHOW_ATTENTION_POINTS_PANEL]: show,
  [actionTypes.HIDE_ATTENTION_POINTS_PANEL]: hide,
  [actionTypes.FETCH_APPOINTMENT_REQUEST]: hide,
});
